var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78046 0.424919C3.9185 0.820384 2.02522 2.20375 1.18204 3.78446C-0.0885674 6.16639 0.118548 8.93445 1.72662 11.0636C2.39361 11.9465 3.86115 12.6167 4.70659 12.4243C5.06009 12.3437 6.98732 11.3949 8.98906 10.3157C13.7552 7.74635 14.8853 7.16344 15.5592 6.92608C16.2696 6.67615 16.2622 6.48471 15.5181 5.85227C15.0497 5.45433 14.7932 5.36746 14.3509 5.45681C14.0391 5.51986 11.8294 6.61596 9.44045 7.89303C4.16843 10.711 3.8106 10.7699 2.90046 8.96817C2.072 7.32802 2.67505 4.49157 4.08298 3.40709C6.12924 1.83095 8.51918 1.99668 10.6775 3.86447C11.3396 4.43728 11.3947 4.45119 12.0569 4.20926C13.2344 3.77932 13.2423 3.58883 12.1271 2.51863C10.2683 0.734852 7.93877 -0.0337891 5.78046 0.424919ZM15.1752 9.06513C14.7083 9.30763 13.7322 9.83054 13.0059 10.2271C7.74919 13.0977 6.48952 13.7644 5.77669 14.0523L4.96936 14.3786L5.40358 14.8504C6.38917 15.9208 7.03485 15.7728 10.9378 13.581C12.0647 12.9482 13.7693 12.03 14.726 11.5408C16.3394 10.7158 16.5073 10.6685 17.0373 10.8903C18.1968 11.3752 18.7812 13.2438 18.3815 15.1878C18.1876 16.1319 18.0067 16.4466 17.1828 17.2735C15.3059 19.1575 12.9424 19.1939 10.7597 17.3722C10.2608 16.9558 9.73716 16.6152 9.59645 16.6152C9.24956 16.6152 8.00724 17.2234 8.00724 17.3933C8.00724 17.6762 10.1712 19.5116 11.0121 19.9419C12.8124 20.8633 14.8958 20.9047 16.7936 20.057C17.2786 19.8402 17.7734 19.663 17.893 19.663C18.0127 19.663 18.6147 20.1774 19.2307 20.806C20.3546 21.9528 20.735 22.1177 21.4124 21.7518C22.1071 21.3763 21.8614 20.6612 20.5794 19.328L19.3814 18.0821L19.9664 16.9369C20.4962 15.8993 20.5506 15.6293 20.5455 14.0604C20.5391 12.0961 20.2041 11.1097 19.1194 9.86216C17.9871 8.55975 16.6631 8.2923 15.1752 9.06513Z",
    fill: "url(#paint0_linear_4478_1522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4478_1522",
    x1: 11.0745,
    y1: 6.69256,
    x2: 11.0745,
    y2: 21.9257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65D996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapLogo);
export default __webpack_public_path__ + "static/media/swapLogo.593317dcb715a27f358a955584b0451d.svg";
export { ForwardRef as ReactComponent };